/**
 * Andys 11 brennende Themen — extrahiert aus Tracking/AUDIO_INSIGHTS_2026-05-03.md.
 * Quelle: Andy's WhatsApp-Sprachnachrichten + KW-Drill-Plan in Tracking/DRILL_KALENDER.md.
 *
 * Konvention: id ASCII-kebab-case (URL/CSS-friendly), label mit echten Umlauten.
 * tagPatterns enthält BEIDE Schreibweisen (Umlaut + ASCII) fuer Robustheit
 * gegenueber Tag-Inkonsistenzen in cards/*.md.
 */

export interface BurningTopic {
  id: string;
  label: string;
  emoji: string;
  drillKw: number;
  /** Tag-Patterns die zu diesem Thema gehoeren (lowercase substring match auf card.tags) */
  tagPatterns: string[];
}

export const BURNING_TOPICS: readonly BurningTopic[] = [
  {
    id: 'brennwert',
    label: 'Brennwert',
    emoji: '🔥',
    drillKw: 19,
    tagPatterns: ['brennwert'],
  },
  {
    id: 'heizwert',
    label: 'Heizwert',
    emoji: '📏',
    drillKw: 19,
    tagPatterns: ['heizwert', 'h_u', 'h_o'],
  },
  {
    id: 'waermepumpe',
    label: 'Wärmepumpe',
    emoji: '🌡️',
    drillKw: 20,
    tagPatterns: ['wärmepumpe', 'waermepumpe', 'cop', 'jaz'],
  },
  {
    id: 'solarthermie',
    label: 'Solarthermie',
    emoji: '☀️',
    drillKw: 21,
    tagPatterns: ['solar', 'kollektor'],
  },
  {
    id: 'oelheizung',
    label: 'Ölheizung',
    emoji: '🛢️',
    drillKw: 22,
    tagPatterns: ['oelheizung', 'ölheizung', 'heizoel', 'heizöl', 'duese', 'düse'],
  },
  {
    id: 'hydraulik',
    label: 'Hydraulik / Abgleich',
    emoji: '⚙️',
    drillKw: 23,
    tagPatterns: ['hydraulisch', 'abgleich', 'pumpe', 'mag', 'druckverlust'],
  },
  {
    id: 'lueftung',
    label: 'Lüftung / KWL',
    emoji: '💨',
    drillKw: 24,
    tagPatterns: ['kwl', 'lüftung', 'lueftung', 'din1946', 'wrg'],
  },
  {
    id: 'abwasser',
    label: 'Abwasser',
    emoji: '🚽',
    drillKw: 25,
    tagPatterns: ['abwasser', 'fallleitung', 'belüftung', 'belueftung', 'abscheider', 'siphon'],
  },
  {
    id: 'trinkwasser',
    label: 'Trinkwasser / TWE',
    emoji: '💧',
    drillKw: 26,
    tagPatterns: [
      'trinkwasser',
      'twe',
      'mischtemperatur',
      'wasserhärte',
      'wasserhaerte',
      'legionellen',
    ],
  },
  {
    id: 'hauswasser',
    label: 'Hauswasser',
    emoji: '🏠',
    drillKw: 27,
    tagPatterns: ['hauswasser', 'hausanschluss', 'druckminderer', 'sicherheitsgruppe'],
  },
  {
    id: 'gas',
    label: 'Gas-Installation',
    emoji: '🔥',
    drillKw: 28,
    tagPatterns: ['gas', 'tae', 'hae', 'gs-hahn', 'kas', 'trgi'],
  },
] as const;

export const BURNING_TOPIC_IDS = BURNING_TOPICS.map((t) => t.id);
